import { Component} from '@angular/core'; 
import {ActivatedRoute } from '@angular/router';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service'; 
import { Product } from '../../models/products/product.model'; 
import { Brand } from '../../models/brand/brand-model'; 
import { Customer } from '../../models/customer/customer-model';
import { EnumDropDown } from '../../models/shared/enum-dropdown'
import { AdminOrderDetail } from '../../models/PurchaseOrder/create-purchase-order.model'; 
import { PurchaseOrderDetailView } from '../../models/PurchaseOrder/purchase-order-detail-view.model';
import { OrderDetail } from '../../models/order/order-detail.model';

@Component({
  selector: 'app-purchase-order-detail',
  templateUrl: './purchase-order-detail.component.html',
  styleUrls: ['./purchase-order-detail.component.scss']
})
/** purchase-order-detail component*/
export class PurchaseOrderDetailComponent {
  public orderDetail: PurchaseOrderDetailView;
  public orderdetails: OrderDetail[];
  public unVerfiedProducts: number[] = [];
  public ProductList: Product[];
  public ProductToAdd: AdminOrderDetail;
  public vendorProductList: Product[];
  public customerList: Customer[];
  public brandtList: Brand[];
  public productidDistinct: number[];
  public orderStatuses: EnumDropDown[];
  public purchasOrderStatuses: EnumDropDown[];
  public ProductType: string;
  public sumQuantity: number;
  public total: number;
  public commissionTotal: number; 
  public totalBalance: number;
  public orderDetailPrintComponent: string;
  public discountRow: string;
  public vendorSKU: string; 
  public sku: string;
  public product: Product;
  /** purchase-order-detail ctor */
  constructor(private readonly purchaseOrderService: PurchaseOrderService,  
    private _avRoute: ActivatedRoute )
     {
    if (this._avRoute.snapshot.params["id"]) {
      this.orderDetail = new PurchaseOrderDetailView(); 
      this.orderDetail.products = [];
      this.GetOrderDetail(this._avRoute.snapshot.params["id"]);
      this.ProductType = "Recent"; 
    }
  }
  GetOrderDetail(id: string) {
    this.purchaseOrderService.GetPurchaseOrderDetailByID(id).subscribe(
      data => {
        this.orderDetail = data; 
        this.getSumAndQuantity();
      });
  }

  getSumAndQuantity() {
    this.sumQuantity = 0;
    this.total = 0;
    this.commissionTotal = 0.00;  
    this.totalBalance = 0.00; 
    for (let i = 0; i < this.orderDetail.products.length; i++)
    {
      this.sumQuantity = this.sumQuantity + this.orderDetail.products[i].quantity;
      this.total = this.total + (this.orderDetail.products[i].quantity * this.orderDetail.products[i].unitBalance);
      this.commissionTotal = this.commissionTotal + this.orderDetail.products[i].unitComission;
      this.totalBalance = this.totalBalance + this.orderDetail.products[i].unitBalance;

    }
    this.commissionTotal = parseFloat((Math.round(this.commissionTotal * 100) / 100).toFixed(2));//parseFloat(Math.round(num3 * 100) / 100).toFixed(2);
    this.totalBalance = parseFloat((Math.round(this.totalBalance * 100) / 100).toFixed(2));//parseFloat(Math.round(num3 * 100) / 100).toFixed(2);
    this.sumQuantity = parseFloat((Math.round(this.sumQuantity * 100) / 100).toFixed(2));//parseFloat(Math.round(num3 * 100) / 100).toFixed(2);

  }

  print(): void {
    let printContents, popupWin;
    printContents = (document.getElementById('print-section') as HTMLElement).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Order Detail</title>
          <style>
            body{font-family:Arial!important}
            table{font-family:Arial!important;width:100%!important;max-width:100%!important;border: 1px solid #ddd!important;}
            .checkoutProductImage{width: 55px !important;height: auto !important;margin: 8px !important;vertical-align: middle;}
            table th, table td {vertical-align: middle !important;padding: 10px;border-bottom: 1px solid #ddd!important;text-align:left!important}
            table th{background-color:#fafafa!important}
            a{text-decoration:none!important;}
            .invoice-img-show{display: block;}
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  } 
}



// WEBPACK FOOTER //
// ./src/app/order-components/purchase-order-detail/purchase-order-detail.component.ts